import React from 'react'
import { BillingCard, HeaderLinks } from './components'
import { BillingModal } from './components/billing-modal'
import * as S from './styles'
type Props = {
  handleConsumption: (modalBox: any) => void
  consumptionTable: any
  consumptionPeriods: string[]
  setPeriods: React.Dispatch<React.SetStateAction<string>>
  consumptionBody: JSX.Element[]
}
const Billing = ({
  handleConsumption,
  consumptionTable,
  consumptionPeriods,
  setPeriods,
  consumptionBody
}: Props) => {
  return (
    <S.Wrapper>
      <S.Title>Alterar senha</S.Title>
      <S.CardContainer>
        <HeaderLinks
          routes={['/meus-dados', '/alterar-senha', '/meu-faturamento']}
        />
        <BillingCard
          title="Meu consumo"
          body={
            <div>
              {consumptionBody}
              <div
                className="modal-click"
                onClick={() => {
                  return handleConsumption(
                    <BillingModal
                      setPeriods={setPeriods}
                      header="Consumo"
                      table={consumptionTable}
                      options={consumptionPeriods}
                    />
                  )
                }}
              >
                Ver meu historico de consumo
              </div>
            </div>
          }
        />
        <BillingCard title="Formas de pagamento" />
        <BillingCard
          title="Faturamento"
          body={
            <div>
              <span
                onClick={() => {
                  return handleConsumption(
                    <BillingModal
                      header="Pagamentos"
                      table={[]}
                      options={[]}
                      setPeriods={setPeriods}
                    />
                  )
                }}
              >
                Ver meu historico de pagamentos
              </span>
            </div>
          }
        />
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Billing
